import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const MergeCommandsOptionDialog = ({
  open,
  handleClose,
  handleMergeCommand
}) => (
  <div>
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        Expédition des commandes
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Voulez-vous expédier toute les commandes fusionnées ?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => handleMergeCommand(false)}
          color="primary"
          variant="contained"
        >
          Ne pas expédier
        </Button>
        <Button
          onClick={() => handleMergeCommand(true)}
          color="primary"
          variant="contained"
          autoFocus
        >
          Expédier
        </Button>
      </DialogActions>
    </Dialog>
  </div>
);

MergeCommandsOptionDialog.propTypes = {
  handleClose: PropTypes.func.isRequired,
  handleMergeCommand: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired
};

export default MergeCommandsOptionDialog;
